import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConnectKitProvider, getDefaultConfig } from 'connectkit';
import { createConfig, http, WagmiProvider } from 'wagmi';
import { mainnet } from 'wagmi/chains';

const config = createConfig(
  getDefaultConfig({
    // Your dApps chains
    chains: [mainnet],

    transports: {
      [mainnet.id]: http(`https://eth-mainnet.g.alchemy.com/v2/2P-Dl55AC-wRfFXnKxUN9HKZqur8-cnW`),
    },

    walletConnectProjectId: '43f72724b32fc23ff04a4214b41575b2',

    // Required App Info
    appName: 'Mercle',
    autoConnect:true,

    // Optional App Info
    appDescription: 'Your App Description',
    appUrl: 'https://family.co',
    appIcon: 'https://family.co/logo.png',
  }),
);

const queryClient = new QueryClient();

export const Web3Provider = ({ children }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider theme='soft'>{children}</ConnectKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};
